import { ELolCategory } from "@api/models/ICategory";
import ApiResultHelper from "@helpers/apiResult.helper";
import type IProduct from "../models/IProduct";
import LOL_API from "./lolFetcher";

const BASE_URL = "/categories";

class CategoryAPI {
  static getBotsProducts = () => {
    return LOL_API.get<IProduct[]>(
      `${BASE_URL}/${ELolCategory.NORMAL}/products`,
    );
  };

  static getHandlevelProducts = async (params?: { normalized?: boolean }) => {
    const productRes = await LOL_API.get<IProduct[]>(
      `${BASE_URL}/${ELolCategory.HANDLEVEL}/products`,
    );

    if (!params?.normalized) return productRes.data;

    return ApiResultHelper.normalizeResultLength(productRes.data);
  };
}
export default CategoryAPI;
